import { useAuth } from '../../Components/AuthContext/AuthContext'
import './dashboard.css'
import React, { Suspense } from 'react';
import NutritionistAIAd from './NutritionistAIAd/NutritionistAIAd';
import TodayMeal from './TodayMeal/TodayMeal';
import DailyWater from './DailyWater/DailyWater';
import Grocery from './Grocery/Grocery';
import UpcomingMeal from './UpcomingMeal/UpcomingMeal';
import IntakeOverview from './IntakeOverview/IntakeOverview';
import DashboardMoney from './Money/Money';
import NutritionistAI from './NutritionistAI/NutritionistAI';

function Dashboard({ setEditMeal }) {
    const { currentUser, userInfo } = useAuth();

    return (
        <div className='dashboard_one_column_grid'>
            <div className='dashboard_three_column_grid'>
                <div className='grid_2_span dashboard_indiv_components'>
                    <IntakeOverview currentUser={currentUser} />
                </div>


                <div className='grid_1_span dashboard_indiv_components'>
                    <TodayMeal currentUser={currentUser} userConfig={userInfo} setEditMeal={setEditMeal} />
                </div>
            </div>

            <div className='dashboard_two_column_grid'>
                <div className='dashboard_indiv_components'>
                    <DailyWater currentUser={currentUser} />
                </div>

                {
                    userInfo && !userInfo.active_subscription ?
                        <div className='dashboard_indiv_components'>
                            <NutritionistAIAd />
                        </div>
                        : <div className='dashboard_indiv_components'>
                            <NutritionistAI />
                        </div>

                }

            </div>

            <div className='dashboard_three_column_grid'>
                <div className='dashboard_indiv_components'>
                    <UpcomingMeal currentUser={currentUser} />
                </div>

                <div className='dashboard_indiv_components'>
                    <DashboardMoney currentUser={currentUser} userConfig={userInfo} />
                </div>

                <div className='dashboard_indiv_components'>
                    <Grocery currentUser={currentUser} />
                </div>
            </div>
            <br />
        </div>
    );
}


export default Dashboard;